import React from 'react';

// FormWarrantyClaims.jsx içinde closure fonksiyon olarak tanımlı `renderFieldDual`ın
// yapısal (davranış değişikliği olmadan) component'e çıkarılmış hali.
const FormFieldPair = ({ firstLabel, firstContent, secondLabel, secondContent, firstRequired = false, secondRequired = false }) => (
    <div className="col-12 md:col-4">
        <div className="grid">
            <div className="col-6">
                <div className="field">
                    <label className="font-bold block">
                        {firstLabel}
                        {firstRequired && <span className="text-red-500 ml-1">*</span>}
                    </label>
                    {firstContent}
                </div>
            </div>
            <div className="col-6">
                <div className="field">
                    <label className="font-bold block">
                        {secondLabel}
                        {secondRequired && <span className="text-red-500 ml-1">*</span>}
                    </label>
                    {secondContent}
                </div>
            </div>
        </div>
    </div>
);

export default FormFieldPair;
